import { combineEpics } from "redux-observable";
import associationsFetch from "./associations-fetch";

export default combineEpics(associationsFetch);
